<div class="login-body">
    <!-- <div class="login-image">
        <img [src]="'assets/layout/images/pages/login-'+ (app.colorScheme === 'dark' ? 'ondark' : 'onlight') + '.png'"
             alt="atlantis">
    </div> -->
    <div class="login-panel p-fluid">
        <div>
            <h1 style="text-align: center;">
                Você será redirecionado para o Portal do Aluno.
            </h1>
            <h3 style="text-align: center;">
                Caso isto não aconteça, clique no link <a href="{{linkPortal}}" >Portal do Aluno</a>.
            </h3>
        </div>
        <!-- <div class="p-d-flex p-flex-column">
            <div class="p-d-flex p-ai-center p-mb-6 logo-container"> -->
                <!-- <img [src]="'assets/layout/images/logo-'+ (app.colorScheme === 'light' ? 'dark' : 'light') + '.png'"
                     class="login-logo"/> -->
                <!-- <img [src]="'assets/layout/images/uniftc-logo.png'"
                     class="login-logo"/> -->
                <!-- <img [src]="'assets/layout/images/appname-'+ (app.colorScheme === 'light' ? 'dark' : 'light') + '.png'"
                    class="login-appname"/> -->
                <!-- <h1 class="login-appname">Login</h1>
            </div>
            <div class="form-container">
                <span class="p-input-icon-left">
                    <i class="pi pi-envelope"></i>
                    <input type="text" autocomplete="off" pInputText placeholder="Login"  [(ngModel)]="loginUsuario" >
                </span>
                <span class="p-input-icon-left">
                    <i class="pi pi-key"></i>
                    <input type="password" autocomplete="off" pInputText placeholder="Senha">
                </span>
                <a href="#" class="p-d-flex">Esqueceu sua senha?</a>
            </div>
            <div class="button-container">
                <button type="button" pButton label="Login" (click)="login()"></button> -->
                <!-- <button type="button" pButton label="Login" [routerLink]="['/solicitacao']"></button> -->
            <!-- </div>
        </div> -->

        <div class="login-footer p-d-flex p-ai-center">
            <div class="p-d-flex p-ai-center login-footer-logo-container">
                <img src="assets/images/uniftc-azul.png" class="login-footer-appname"/>
            </div>
            <span>Copyright 2022</span>
        </div>
    </div>
</div>
